import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/app/[locale]/reviews/reviews.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4eff1d363bb9/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerReviewCard"] */ "/tmp/8de4eff1d363bb9/components/sections/CustomerReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GuestReviewCard"] */ "/tmp/8de4eff1d363bb9/components/sections/GuestReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerReviewsGrid"] */ "/tmp/8de4eff1d363bb9/components/sections/PartnerReviewsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/tmp/8de4eff1d363bb9/components/sections/ReviewSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4eff1d363bb9/components/ui/Container.module.css");
